import React from 'react';
import * as icons from './IconPackage';

const Icons = ({name, props}) => {
    const IconComponent = icons[name];

    return (
        <IconComponent {...props} />
    )
};

export default Icons;
